export const excludeExamsIds = [17]

export const extraExams = 'extraExamsID'

export const tooltipText = [
  {
    id: 8,
    position: 'top-center',
    text: 'Вузы могут его перепроверять или не перепроверять и, соответственно, выставлять за этот экзамен одинаковое количество баллов всем абитуриентам «за наличие» или ранжировано — «за качество»',
  },
  {
    id: 4,
    position: 'left-top',
    text: 'Значок и удостоверение к нему для выполнивших нормативы Всероссийского физкультурно-спортивного комплекса «Готов к труду и обороне»',
  },
  {
    id: 3,
    position: 'left-top',
    text: 'Звания чемпиона мира, Европы или Олимпийских (и Паралимпийских) игр, статус мастера спорта или кандидата в мастера спорта',
  },
  {
    id: 5,
    position: 'left-top',
    text: 'Документы, подтверждающие участие в волонтерских проектах',
  },
  {
    id: 7,
    position: 'left-top',
    text: 'Не используемые для получения особых прав - зачисление без вступительных экзаменов и 100 баллов по предмету ЕГЭ',
  },
  {
    id: 9,
    position: 'left-top',
    text: 'Для участников городских проектов «Инженерный класс», «Медицинский класс», «Академический класс» и «Кадетский класс»',
  },
  {
    id: 10,
    position: 'left-top',
    text: 'Наличие статуса победителя/призера национального или международного чемпионата по профессиональному мастерству среди инвалидов и лиц с ограниченными возможностями здоровья (ОВЗ)',
  },
]

export const achievementsShort = [
  {
    id: 1,
    text: 'Аттестат с отличием',
  },
  {
    id: 2,
    text: 'Диплом СПО с отличием',
  },
  {
    id: 8,
    text: 'Итоговое сочинение',
  },
  {
    id: 6,
    text: 'Золотой значок ГТО',
  },
  {
    id: 3,
    text: 'Спортивные достижения',
  },
  {
    id: 5,
    text: 'Волонтерская деятельность',
  },
  {
    id: 7,
    text: 'Победы в олимпиадах и творческих конкурсах',
  },
  {
    id: 9,
    text: 'Результаты предпрофессионального экзамена',
  },
  {
    id: 10,
    text: 'Победа в чемпионате «Абилимпикс»',
  },
]
